import { ChangeDetectionStrategy, Component, computed, inject, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { AbstractDialogData, AnimationDialogService } from '@pc/dialog-abstract';
import { PcButtonIcon } from '@pc/common';
import { ErrorPopupComponent } from '@pc/error-popup';

interface AlertPopupData {
  title: string;
  description: string;
  information: string;
  desktopImgPath: string;
  mobileImgPath: string;
  imgAlt: string;
  customContent: string;
  closePopUpAriaLabel: string;
  buttonText: string;
  submitAction: () => void;
}

@Component({
  selector: 'pc-alert-popup',
  standalone: true,
  imports: [CommonModule, ErrorPopupComponent],
  templateUrl: './alert-popup.component.html',
  styleUrl: './alert-popup.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AlertPopupComponent {
  public closePopUpAriaLabel = computed(() => this.data.event?.closePopUpAriaLabel || '');
  public title = computed(() => this.data.event?.title || '');
  public desktopImgPath = computed(() => this.data.event?.desktopImgPath || '');
  public mobileImgPath = computed(() => this.data.event?.mobileImgPath || '');
  public imgAlt = computed(() => this.data.event?.imgAlt || '');
  public description = computed(() => this.data.event?.description || '');
  public information = computed(() => this.data.event?.information || '');
  public buttonText = computed(() => this.data.event?.buttonText || 'Continue');
  public customContent = computed(() => this.data.event?.customContent || '');
  public readonly PcButtonIcon = PcButtonIcon;

  private dialogRef = inject(DialogRef);
  private animationDialogService = inject(AnimationDialogService);

  constructor(@Inject(DIALOG_DATA) public data: AbstractDialogData<AlertPopupData>) {}

  closeWithSubmit(): void {
    this.data.event?.submitAction?.();
    this.animationDialogService.closeDialogWithAnimation(this.dialogRef);
  }

  closeDialog(): void {
    this.animationDialogService.closeDialogWithAnimation(this.dialogRef);
  }
}
